import React, { FC, useEffect } from 'react';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';
import { Container } from '@components/atoms/Container';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { useThemes } from '@hooks/useThemes';
import { useData } from '@hooks/useData';
import { useHtmlTransformer } from '@hooks/useHtmlTransformer';
import styles from './CallToAction.module.css';
import { useGetAllSettings } from '@services/useGetAllSettings';

export const CallToAction: FC = () => {
    const { transformHtml } = useHtmlTransformer();
    const { allSettings } = useData();
    const { request: requestAllSettings } = useGetAllSettings();
        
    useEffect(() => {
        requestAllSettings();
    }, []);

    return (
        <div className={`call-to-action ${styles['call-to-action']} position-relative`} data-testid="call-to-action">
            <Background />
            <img
                src={allSettings?.data?.content_join_marketplace_image}
                className="position-absolute bottom-0"
                alt={allSettings?.data?.marketplaceName}
            />
            <Container classes="d-flex py-5 text-light align-content-center">
                <div className="row flex-grow-1 align-self-center">
                    <div className="px-3 ms-1 col-7">
                        <Typography fontSize="12" classes="mb-3 mb-lg-1" styles={{ spacedText: true }}>
                            {allSettings?.data?.content_join_marketplace_section_label &&
                                transformHtml(allSettings?.data?.content_join_marketplace_section_label)}
                        </Typography>
                        <Typography
                            tagVariant={TypographyTagVariants.h2}
                            classes="lh-sm mb-3 text-light"
                            appearanceLevel={TypographyAppearanceVariants.level1}>
                            {allSettings?.data?.content_join_marketplace_title &&
                                transformHtml(allSettings?.data?.content_join_marketplace_title)}
                        </Typography>
                        <div className="mt-2 me-md-2">
                            <Anchor href={allSettings?.data?.content_join_marketplace_button_link} mode={AnchorMode.light}>
                                {allSettings?.data?.content_join_marketplace_button_label
                                    ? transformHtml(allSettings?.data?.content_join_marketplace_button_label)
                                    : ''}
                            </Anchor>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

const Background: FC = () => {
    const { useGrayscaleTheme } = useThemes();
    const { allSettings } = useData();

    return (
        <div
            className={
                // theme
                `${useGrayscaleTheme ? styles['theme-grayscale'] : ''}` +
                // other classes
                ` ${styles.background}`
            }
            style={{ backgroundColor: allSettings?.data?.content_join_marketplace_bg_color }}></div>
    );
};
